/* ============================================================
   TRADIE — Junip rating badge behaviour:

   1. Make the rating pill near the product title click/keyboard-
      activate to scroll down to the Junip reviews carousel
      further down the page. Target selector
      (.junip-review-carousel) is the same one pf-trust-badges
      already uses for its "Over 2k 5 Star Reviews" icon's
      scroll_selector setting — a confirmed, already-working
      selector on this page, not a guess.

   2. Overwrite the exact review count shown above the review
      carousel itself ("4.50 ★ | 2,382 reviews") with the same
      editable text used for the title-area badge (Theme Settings
      → "TRADIE — Rating badge (product page)"). That element
      (div.junip-review-carousel-summary-review-count) renders at
      0 height and a plain CSS ::after on it never actually
      appeared, so this is done via direct textContent replacement
      instead — more reliable for this particular element. The
      text itself comes from a data attribute on <body>
      (data-pf-rating-badge-text), set in layout/theme.liquid from
      settings.pf_rating_badge_text.

   Junip renders both of these asynchronously after its own
   script runs (data-initialized="true" gets set post-render), so
   a plain DOMContentLoaded listener isn't reliable on its own —
   a MutationObserver picks them up whenever they actually appear.
   ============================================================ */

(function () {
  function getBadgeText() {
    return document.body.getAttribute('data-pf-rating-badge-text') || 'Reviews';
  }

  function scrollToReviews() {
    var target = document.querySelector('.junip-review-carousel');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function wireUpTitleBadge(badge) {
    if (!badge || badge.dataset.pfScrollLinked === 'true') return;
    badge.dataset.pfScrollLinked = 'true';

    badge.setAttribute('role', 'link');
    badge.setAttribute('tabindex', '0');
    badge.setAttribute('aria-label', 'View reviews');

    badge.addEventListener('click', scrollToReviews);
    badge.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        scrollToReviews();
      }
    });
  }

  function overwriteCarouselSummaryCount(el) {
    if (!el || el.dataset.pfTextOverridden === 'true') return;
    el.dataset.pfTextOverridden = 'true';
    el.textContent = getBadgeText();
  }

  function initJunipRatingBadges() {
    var titleBadge = document.querySelector('.junip-product-summary');
    if (titleBadge) wireUpTitleBadge(titleBadge);

    var carouselCount = document.querySelector('.junip-review-carousel-summary-review-count');
    if (carouselCount) overwriteCarouselSummaryCount(carouselCount);
  }

  document.addEventListener('DOMContentLoaded', initJunipRatingBadges);
  document.addEventListener('shopify:section:load', initJunipRatingBadges);

  var observer = new MutationObserver(function () {
    initJunipRatingBadges();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
